import { getUserLoading } from '@abovo/shared-auth';
import { ThemeAnimationsService, ThemeV2Service, WindowResizeService } from '@abovo/shared-services';
import { EmployeesStore } from '@abovo/webvis-data-access';
import { AfterViewInit, Component, NgZone, OnDestroy, Renderer2 } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { combineLatest, debounceTime, map, skip, takeWhile } from 'rxjs';

@Component({
   selector: 'abovo-root',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.scss'],
   standalone: false,
})
export class AppComponent implements AfterViewInit, OnDestroy {
   showSplashScreen = toSignal(
      combineLatest([this.store.select(getUserLoading), toObservable(this.employeesStore.loading)]).pipe(
         // Skip first value because it would result in false, ending this observable
         skip(1),
         map(([loadingUser, loadingEmployees]) => loadingUser || loadingEmployees),
         // Debounce because there is a brief moment in which we are not loading user and not loading employees
         debounceTime(100),
         // Stop the observable when the splash screen is hidden, because it only needs to be shown on startup
         takeWhile(Boolean, true),
      ),
   );

   private stopResizeListener: () => void;

   constructor(
      private store: Store,
      private renderer: Renderer2,
      private resizeService: WindowResizeService,
      private ngZone: NgZone,
      public themeService: ThemeV2Service,
      public themeAnimationService: ThemeAnimationsService,
      private employeesStore: EmployeesStore,
   ) {}

   ngAfterViewInit() {
      this.ngZone.runOutsideAngular(() => {
         this.stopResizeListener = this.renderer.listen('window', 'resize', (event) => {
            this.resizeService.onResize(event);
         });
      });
   }

   ngOnDestroy() {
      this.stopResizeListener();
   }
}
